import { tv } from '@/utils/libs/tailwind-variants';
/**
 * ContentContainer の variant class を生成する関数
 * @note 使用箇所が多いため、関数を直接使用してOK
 */
export const contentContainerStyle = tv({
    base: ['max-w-[1200px]', 'md:w-[calc(100%-100px)]'],
    defaultVariants: {
        isMinWidthFull: false,
        maxWidthPoint: 'lg',
    },
    variants: {
        isMinWidthFull: {
            false: 'w-[calc(100%-30px)]',
            true: 'w-full',
        },
        maxWidthPoint: {
            lg: 'lg:w-[calc(100%-200px)]',
            xl: 'lg:w-[calc(100%-120px)] xl:w-[calc(100%-200px)]',
        },
    },
});
